import { Stack, Typography } from '@mui/material';

import { FSModal } from '@/ui/components/modal/FSModal';
import { FSModalTitle } from '@/ui/components/modal/FSModalTitle';
import { translate } from '@/ui/i18n';

export function ModalCarbonBudgetHelp({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  return (
    <FSModal open={open} onClose={onClose} showCloseButton={true}>
      <Stack spacing={3}>
        <FSModalTitle
          title={translate('ProjectsVenue.why-define-a-carbon-budget')}
        />
        <Typography>
          {translate('ProjectsVenue.why-define-a-carbon-budget-description')}
        </Typography>
      </Stack>
    </FSModal>
  );
}
